import { render } from "./ProgramTagListViewEditItemPane.vue?vue&type=template&id=30c46645&scoped=true&ts=true"
import script from "./ProgramTagListViewEditItemPane.vue?vue&type=script&lang=ts"
export * from "./ProgramTagListViewEditItemPane.vue?vue&type=script&lang=ts"

import "./ProgramTagListViewEditItemPane.vue?vue&type=style&index=0&id=30c46645&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c46645"]])

export default __exports__